//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'; 
export default {
  name: 'collect',
  components: {
  },
  data () {
    return {
      id:0,
      code:'',
      order:{},
      submitStatus:false,
    }
  },
  created(){
   this.config();
  },
  mounted(){
   
  },
  methods:{
    scanQRCode(){
        let that = this;
        wx.ready(()=> {
            wx.scanQRCode({
            needResult: 1,
            scanType: ["qrCode"],
            success: function (res) {
                setTimeout(()=>{
                    // that.formData[id] = res.resultStr.split(',')[1];
                    if(res.resultStr.indexOf(",") != -1){
                      that.code = res.resultStr.split(',')[1];
                    }else{
                      that.code = res.resultStr;
                    }
                    that.getOutOrder();
                },300);
            }
            })
        });
        wx.error((res)=> {
            console.log(res)
            // alert(res.errMsg);
        })
    },  
    config(){
        let url = (window.location.href).split('#');
        if(url[0].indexOf('?') != '-1'){
            url = url[0].split('?');
        }
        this.$api.wxSign({url:url[0]}).then((res)=>{
            if(res){
                wx.config({
                    debug: false, 
                    appId: res.data.appId,
                    timestamp: res.data.timestamp,
                    nonceStr: res.data.nonceStr,
                    signature:res.data.signature,
                    jsApiList: [
                        "scanQRCode"
                    ]
                });
            }
        })
    },
    getOutOrder(){
      if(!this.code){
        this.$func.showToast('订单号无效');
        return ;
      }
      this.$api.getOutOrder({code:this.code}).then((res)=>{
        if(res){
          this.id = res.data.id;
          this.order = res.data;
          this.submitStatus = true;
        }
      })  
    },
    submit(){
      if(!this.submitStatus){
        return false;
      }
      if (!this.code) {
          this.$func.showToast('订单号无效');
          return false;
      }
      this.$api.outHouse({id:this.id}).then((res)=>{
        if(res){
          this.$func.showToast('出库成功');
          // wx.ready(function () {
          //     let media = document.getElementById("musicBox");
          //     media.src = "https://wash.uunbiot.com/uploads/default/shouyicheggong.mp3"
          //     media.play();
          // });
          setTimeout(()=>{
            this.id = 0;
            this.order = {};
            this.code = '';
            this.submitStatus = false;
          },300)
        }
      })  
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/outHouseCode.vue